module.exports = __webpack_public_path__ + "img/tree-07-h-leaves.4a044ff7.png";